'use strict';

var clear = require('./clear.js');
var selectOptions = require('./selectOptions.js');
var type = require('./type.js');
var upload = require('./upload.js');



exports.clear = clear.clear;
exports.deselectOptions = selectOptions.deselectOptions;
exports.selectOptions = selectOptions.selectOptions;
exports.type = type.type;
exports.upload = upload.upload;
